module.exports = __webpack_public_path__ + "img/addressIcon.19fbee1e.png";